module.exports = __webpack_public_path__ + "resources/images/ziekenhuis-1445340f6a99ad92d21d8d808fa6e297-cache.jpg";